export default "__VITE_ASSET__CQj3bPYd__"